export default "__VITE_ASSET__B11VOfNq__"